<ng-container *ngIf="newsItem | async as newsItem">
  <article class="cpp-news-item">
    <div class="cpp-news-item__header-image" *ngIf="newsItem.headerImage">
      <picture>
        <source *ngIf="newsItem.headerImage.large" srcset="{{newsItem.headerImage.large}}" media="(min-width: {{breakpoints.LARGE_MIN}}px)">
        <source *ngIf="newsItem.headerImage.medium" srcset="{{newsItem.headerImage.medium}}" media="(min-width: {{breakpoints.MEDIUM_MIN}}px)">
        <source *ngIf="newsItem.headerImage.small" srcset="{{newsItem.headerImage.small}}" media="(min-width: 0px)">
        <img src="{{newsItem.headerImage.large}}" alt="{{newsItem.title}}">
      </picture>
    </div>
      <div class="cpp-news-item__content">
        <h3 class="cpp-news-item__title"> {{newsItem.title}} </h3>
        <span class="cpp-news-item__subtitle" *ngIf="newsItem.subtitle">{{newsItem.subtitle}}</span>
        <div class="cpp-news-item__details">
          <span *ngIf="newsItem.location"> {{newsItem.location}},</span>
          <span *ngIf="newsItem.publicationDate"> {{newsItem.publicationDate | date: 'd MMMM y' }}</span>
        </div>
        <hr class="cpp-news-item__ruler"/>
        <span class="cpp-news-item__introduction" *ngIf="newsItem.introduction">
          {{newsItem.introduction}}
        </span>
        <div class="cpp-news-item__body" [innerHTML]="newsItem.content" *ngIf="newsItem.content"></div>
        <div class="cpp-news-item__business-card-container" *ngIf="newsItem.sales">
          <u4-cpp-account-manager></u4-cpp-account-manager>
        </div>
      </div>
  </article>

  <div class="mt-3">
    <u4-cpp-subscribe></u4-cpp-subscribe>
  </div>
</ng-container>
